/* eslint-disable no-redeclare */

import { type OstroStorageNullableReturnValue, type OstroStorageReturnValue } from './types';
import useStorage, { getStorageItem, removeStorageItem, setStorageItem } from './useStorage';
import { getNamespacedKey } from './utils';

export function getNamespacedStorageItem(key: string, defaultValue: any = null) {
  return getStorageItem(getNamespacedKey(key), defaultValue);
}

export function setNamespacedStorageItem(key: string, value: any) {
  setStorageItem(getNamespacedKey(key), value);
}

export function removeNamespacedStorageItem(key: string) {
  removeStorageItem(getNamespacedKey(key));
}

// This is to allow type inference based on whether a defaultValue is provided:
// const [myValue] = useNamespacedStorage('myKey') <-- myValue is of type string | null
// const [myValue] = useNamespacedStorage('myKey', 'myDefaultValue') <-- myValue is of type string
// const [myNumbers] = useNamespacedStorage<number[]>('myKey') <-- myNumbers is of type number[] | null
// const [myNumbers] = useNamespacedStorage<number[]>('myKey', [1, 2]) <-- myNumbers is of type number[]
function useNamespacedStorage<T = string>(key: string): OstroStorageNullableReturnValue<T>;
function useNamespacedStorage<T = string>(key: string, defaultValue: T): OstroStorageReturnValue<T>;
function useNamespacedStorage<T = string>(key: string, defaultValue: T | null = null) {
  return useStorage(getNamespacedKey(key), defaultValue);
}

export default useNamespacedStorage;
